import { AnyAction } from 'redux'
import { subscribeAfter } from '@wellesley/redux-subscribe-action'
import { useCallback, useRef } from 'react'

import { listenMessage } from '../message/listenMessage'
import { sendMessage } from '../message/sendMessage'
import { getStore } from '@wellesley/store'
import { PayloadAction } from '@reduxjs/toolkit'

type UseRemoteStoreConnectProps = {
  sourceWindow?: Window | null
  sendWhitelist: AnyAction[]
  receiveWhitelist: AnyAction[]
  onMessage?: (action: AnyAction | PayloadAction) => void
  onAction?: (action: AnyAction | PayloadAction) => void
  name?: string
}

export const useStoreConnect = ({
  sourceWindow,
  sendWhitelist,
  receiveWhitelist,
  onMessage,
  onAction,
  name,
}: UseRemoteStoreConnectProps) => {
  const unsubscribeRef = useRef(() => {})
  const removeListenerRef = useRef(() => {})

  return useCallback(
    (windowElement: Window | null) => {
      if (!windowElement) return

      unsubscribeRef.current()
      removeListenerRef.current()

      unsubscribeRef.current = subscribeAfter((action) => {
        onAction?.(action)
        sendMessage({
          action,
          windowElement,
          whitelist: sendWhitelist,
        })
      })

      removeListenerRef.current = listenMessage({
        sourceWindow,
        allowSameOrigin: false,
        onMessage: (action) => {
          onMessage ? onMessage(action) : getStore().dispatch(action)
        },
        whitelist: receiveWhitelist,
      })

      return () => {
        unsubscribeRef.current()
        removeListenerRef.current()
      }
    },
    [
      sourceWindow,
      sendWhitelist,
      receiveWhitelist,
      onMessage,
      subscribeAfter,
      onAction,
      name,
    ],
  )
}
